import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { ContactType } from "types/ContactTypes";

export const useSendContactMessage = (
  options?: UseMutationOptions<any, Error, ContactType>
) => {
  return useMutation({
    ...options,
    mutationKey: ["sendMessage"],
    mutationFn: async (data) => {
      return axiosInstance.post("/contact", data).then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Trwa wysyłanie wiadomości...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "send-message",
      });
      if (options && options.onMutate) {
        // @ts-ignore
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: "Wiadomość została wysłana pomyślnie.",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "send-message",
      });

      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: "Błąd podczas wysyłania wiadomości.",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "send-message",
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useSendContactMessage;
